import { Toast } from '@base-ui/react/toast';

export type ToastType = 'info' | 'success' | 'error';

export const useToast = () => {
  const manager = Toast.useToastManager();

  return {
    push: (message: string, type: ToastType = 'info') => {
      manager.add({
        priority: type === 'error' ? 'high' : 'low',
        title: message,
        type,
      });
    },
  };
};
